// extracted by mini-css-extract-plugin
export default {"key-id":"WdBG","keyId":"WdBG","right-tag":"HIj9","rightTag":"HIj9"};